import React from 'react';

import * as Styled from './LoadingIndicator.styles';

export const LoadingIndicator = props => {
  return (
    <Styled.LoadingIndicator {...props}>
      <Styled.MendedHeart />
    </Styled.LoadingIndicator>
  );
};
